module.exports = __webpack_public_path__ + "static/media/export.686e112e.svg";